import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ConsultasSqlApi, PuestoApi, SectorApi, Turno, TurnoApi } from 'app/shared/lb-sdk';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';


@Component({
  selector: 'app-display-cliente',
  templateUrl: './display-cliente.component.html',
  styleUrls: ['./display-cliente.component.scss']
})
export class DisplayClienteComponent implements OnInit {
  itemEditar = null;
  dniEditar = "";
  nombreEditar = "";
  apellidoEditar = "";
  idSectorEditar = "";
  showModalUsuario = false;
  vendedorDB = []
  idAsignarPuesto = 0;
  sectorDB = []
  loginOk = false;
  showModal = false;
  turnosContactologiaDB = [];
  mostrarSpinner = false;
  turnosOpticaDB = [];
  turnosAtendidosDB = []
  isActive = true;
  @ViewChild('exampleModal') exampleModal: ElementRef;

  turnosLlamados: Array<Turno> = [];
  // ultimoLlamado: Turno = new Turno({ idTurno: -1, numerador: -1, fecha: null, fechaAnulacion: null, horaEntrega: null, horaLlamado: null, horaPedido: null, idPuesto: 1, observaciones: null });
  blink: boolean = false;
  constructor(private sectorApi: SectorApi, private toastr: ToastrService, private turnoApi: TurnoApi, private consultaSql: ConsultasSqlApi, private spinner: NgxSpinnerService,
    public authService: AuthService, private router: Router, private puestoApi: PuestoApi) {
    const formatoFecha = new Intl.DateTimeFormat('es-AR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'America/Argentina/Buenos_Aires', // Establecer la zona horaria deseada
    });

    setInterval(() => {
      this.refrescar();
    }, 4000)
    if (this.authService.userData) {
      this.loginOk = true
    }
    else {

      this.router.navigateByUrl('login-cliente')
    }


  }
  actualizar() {
    //if (this.mostrarSpinner == true) {
    this.spinner.show();
    //  this.mostrarSpinner = false;
    //}
    this.turnoApi.patchAttributes(this.itemEditar.idTurno, {
      apellido: this.apellidoEditar, nombre: this.nombreEditar,
      dni: this.dniEditar, idSector: this.idSectorEditar
    })
      .subscribe(respuesta => {
        this.spinner.hide();
        this.toastr.success("Datos actualizados correctamente")
        this.closeModal();
      }, error => {
        this.spinner.hide();
      })
  }
  buscarDni() {
    //    if (this.mostrarSpinner == true) {
    this.spinner.show();
    //    this.mostrarSpinner = false;
    //  }
    this.consultaSql.GetDatosOlp(this.dniEditar)
      .subscribe(respuesta => {
        this.spinner.hide();
        if (respuesta.success == true) {
          this.nombreEditar = respuesta.nombre;
          this.apellidoEditar = respuesta.apellido
        }
        else {
          this.toastr.error("DNI no encontrado")
        }
      }, error => {
        this.spinner.hide();
      })
    //alert(this.dniEditar)
    //{"success":true,"nombre":"EDUARDO DANIEL","apellido":"FERNANDEZ","afip":true}
  }
  openModal(item) {
    this.itemEditar = item;
    console.log(this.itemEditar)
    this.nombreEditar = item.nombre;
    this.apellidoEditar = item.apellido
    this.idSectorEditar = item.idSector;
    this.dniEditar = item.dni;
    this.showModal = true;
  }

  openModalAsignar(item) {

    this.itemEditar = item;
    /*  console.log(this.itemEditar)
      this.nombreEditar = item.nombre;
      this.apellidoEditar = item.apellido
      this.idSectorEditar = item.idSector;
      this.dniEditar = item.dni;*/
    this.showModalUsuario = true;
  }

  closeModal() {
    this.showModal = false;
  }
  closeModalAsignar() {
    this.showModalUsuario = false;
  }
  ngOnInit(): void {
    //this.sectorApi.find()
    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetSectorSeleccionable",
      data: null
    })
      .subscribe(respuesta => {

        this.sectorDB = respuesta[0]
      })

    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetPuestos",
      data: { idsucursal: 1 }
    }).subscribe(respuesta => {
      this.vendedorDB = respuesta[0]
    })

    this.refrescar();
    /* this.turnoApi.find({ where: { and: [{ idSector: 1 }, { idEstado: 0 }] } })
       .subscribe((respuesta: any) => {
         console.log(respuesta)
         respuesta.forEach(element => {
           element.dni = element.dni.slice(-4)
         });
         this.turnosOpticaDB = respuesta;
       })
     this.turnoApi.find({ where: { and: [{ idSector: 2 }, { idEstado: 0 }] } })
       .subscribe((respuesta: any) => {
         console.log(respuesta)
         respuesta.forEach(element => {
           element.dni = element.dni.slice(-4)
         });
         this.turnosContactologiaDB = respuesta;
       })*/
  }

  // 0-En espera, 1-Atendido, 2-Ausente, 3-Cancelado,4-Finalizado
  async cambiarEstado(idestado: number, turno: Turno) {
    const formatoFecha = new Intl.DateTimeFormat('es-AR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'America/Argentina/Buenos_Aires', // Establecer la zona horaria deseada
    });




    let fechaActual = new Date();
    if (idestado == 1) { //LLAMA
      this.consultaSql.GetStoreDinamic({
        nombreStore: "ValidarLlamado",
        data: {
          idpuesto: this.authService.userData.id_puesto
        }
      })
        .subscribe((respuesta: any) => {
          if (respuesta[0][0].CANTIDAD == 0) {
            this.mostrarSpinner = true;
            this.turnoApi.findById(turno.idTurno)
              .subscribe((res: Turno) => {
                res.idEstado = 1
                res.idPuesto = this.authService.userData.id_puesto
                res.fechaAnulacion = null //VER PORQUE SI ESTA ANULADO Y LO VUELVO A LLAMAR PIERDO ESTA FECHA
                res.fechaLlamado = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000)
                this.turnoApi.updateAttributes(turno.idTurno, res).subscribe()
                this.refrescar();

              })
          }
          else {
            this.toastr.error("Debe finalizar el/los turnos que tenga sin finalizar para poder llamar al próximo.")

          }

        })

      /* this.turnoApi.findById(turno.idTurno)
         .subscribe((res: Turno) => {
           res.idEstado = 1
           res.idPuesto = this.authService.userData.id_puesto
           res.fechaAnulacion = null //VER PORQUE SI ESTA ANULADO Y LO VUELVO A LLAMAR PIERDO ESTA FECHA
           res.fechaLlamado = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000)
           this.turnoApi.updateAttributes(turno.idTurno, res).subscribe()
           this.refrescar();
          
         })*/

    }
    else if (idestado == 2) { //AUSENTE
      this.mostrarSpinner = true;
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {
          res.idEstado = 2 //AUSENTE
          res.fechaAnulacion = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000)
          res.idPuesto = this.authService.userData.id_puesto
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe()
          this.refrescar();
          // this.spinner.hide();
        }, error => {
          this.mostrarSpinner = false
        })
    } else if (idestado == 3) { //AUSENTE
      this.mostrarSpinner = true
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {
          res.idEstado = 3 //FINALIZADO
          res.fechaFinalizacion = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000)
          res.idPuesto = this.authService.userData.id_puesto
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe()
          this.refrescar();
          //this.spinner.hide();
        }, error => {
          this.mostrarSpinner = false
        })

    }
    else if (idestado == 4) { //SI FUE LLAMADO, CAMBIAMOS A ATENDIENDO
      this.mostrarSpinner = true
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {

          res.idEstado = 4 //AUSENTE

          res.fechaAtencion = new Date(fechaActual.getTime() - 3 * 60 * 60 * 1000);
          res.idPuesto = this.authService.userData.id_puesto
          console.log("MANDA ", res)
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe()
          this.refrescar();
          //this.spinner.hide();
        }, error => {
          this.mostrarSpinner = false
        })

    }
    else if (idestado == 0) { //SI FUE LLAMADO, CAMBIAMOS A PENDIENTE
      this.mostrarSpinner = true
      this.turnoApi.findById(turno.idTurno)
        .subscribe((res: Turno) => {

          //res.idEstado = 4 //AUSENTE

          res.fechaAtencion = null;
          res.idPuesto == null;
          res.idEstado = 0;
          console.log("MANDA ", res)
          this.turnoApi.updateAttributes(turno.idTurno, res).subscribe()
          this.refrescar();
          //this.spinner.hide();
        }, error => {
          this.mostrarSpinner = false
        })

    }
  }

  asignarPendiente() {
    this.spinner.show();

    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetPendienteAsignado",
      data: {
        idTurno: this.itemEditar.idTurno,
        idPuestoAsignado: this.idAsignarPuesto
      }
    })
      .subscribe(respuesta => {
        this.spinner.hide();
        this.toastr.success("Datos actualizados correctamente")
        this.closeModal();
        this.refrescar();
      }, error => {
        this.spinner.hide();
      })
  }
  cerrarSesion() {
    this.authService.logout()
    this.router.navigateByUrl('login-cliente')
  }
  verReporte() {
    this.router.navigateByUrl('grilla-turnos')
  }
  refrescar() {
    if (this.mostrarSpinner == true) {
      this.spinner.show();
      this.mostrarSpinner = false;
    }

    /* const observables = [this.consultaSql.GetStoreDinamic({
       nombreStore: "GetTurnosPendientes", data: { IDESTADOFILTRO: "0", IDSECTORFILTRO: "1", IDSUCURSALFILTRO: this.authService.userData.idsucursal }
     }),
     this.consultaSql.GetStoreDinamic({
       nombreStore: "GetTurnosPendientes", data: { IDESTADOFILTRO: "0", IDSECTORFILTRO: "2", IDSUCURSALFILTRO: this.authService.userData.idsucursal }
     }),
     this.consultaSql.GetStoreDinamic({
       nombreStore: "GetTurnosAtendidos", data: { IDESTADOFILTRO: "3", IDSUCURSALFILTRO: this.authService.userData.idsucursal }
     })]*/

    const observables = [this.consultaSql.GetStoreDinamic({
      nombreStore: "GetTurnosPendientesBack", data: { IDESTADOFILTRO: "0", IDSECTORFILTRO: "1", IDSUCURSALFILTRO: this.authService.userData.idsucursal }
    }),
    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetTurnosPendientesBack", data: { IDESTADOFILTRO: "0", IDSECTORFILTRO: "2", IDSUCURSALFILTRO: this.authService.userData.idsucursal }
    }),
    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetTurnosAtendidos", data: { IDESTADOFILTRO: "3", IDSUCURSALFILTRO: this.authService.userData.idsucursal }
    })]


    const joint = forkJoin(observables);
    joint.subscribe((respuesta: any) => {
      this.spinner.hide();
      console.log(respuesta)
      let optica = respuesta[0]
      let contactologia = respuesta[1]
      let atendidos = respuesta[2]
      if (optica[0].length == 0) {
        console.log("No hay datos")
        this.turnosOpticaDB = []
      }
      else {
        this.turnosOpticaDB = optica[0]
      }
      if (contactologia[0].length == 0) {
        console.log("No hay datos")
        this.turnosContactologiaDB = []
      }
      else {
        this.turnosContactologiaDB = contactologia[0]
      }
      if (atendidos[0].length == 0) {
        console.log("No hay datos")
        this.turnosAtendidosDB = []
      }
      else {
        this.turnosAtendidosDB = atendidos[0]
      }
    });
  }
  // refrescar() {
  //   this.turnoApi.find({ where: { and: [{ idSector: 1 }, { idEstado: 0 }] } })
  //     .subscribe((respuesta: any) => {
  //       console.log(respuesta)
  //       respuesta.forEach(element => {
  //         element.dni = element.dni.slice(-4)
  //       });
  //       this.turnosOpticaDB = respuesta;
  //     })
  //   this.turnoApi.find({ where: { and: [{ idSector: 2 }, { idEstado: 0 }] } })
  //     .subscribe((respuesta: any) => {
  //       console.log(respuesta)
  //       respuesta.forEach(element => {
  //         element.dni = element.dni.slice(-4)
  //       });
  //       this.turnosContactologiaDB = respuesta;
  //     })
  // }
  getTurnosLlamados() {
    this.turnoApi.find({
      order: 'horaLlamado DESC',
      where: {
        and: [
          { horaLlamado: { neq: null } },
          { horaEntrega: null },
          { fechaAnulacion: null }
        ]
      }
    })
      .subscribe((turnos: Array<Turno>) => {
        this.turnosLlamados = turnos;
        console.log(this.turnosLlamados)
      })

  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/display-cliente/display-cliente.component.ts